import React from 'react'

const LoadingSpinner = ({  
    size = 'md', 
    color = 'blue',
    fullScreen = true,
    message = 'Cargando...' 
  }) => {

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const colorClasses = {
    blue: 'border-blue-500',
    red: 'border-red-500',
    green: 'border-green-500',
    purple: 'border-purple-500',
    gray: 'border-gray-500'
  };

  const overlayContent = (
    <div className="flex flex-col items-center justify-center gap-3">
      <div 
        className={`
          ${sizeClasses[size]}
          ${colorClasses[color]}
          border-4
          border-t-transparent
          rounded-full
          animate-spin
        `}
        role="status"
        aria-label="Cargando"
      />
      {message && (
        <p className="text-gray-700 font-medium">{message}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div 
        className="fixed inset-0 bg-gray-600 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50"
        onClick={(e) => e.stopPropagation()}
      >
        {overlayContent}
      </div>
    );
  }
  return overlayContent;
}

export default LoadingSpinner
